
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regulaminy-cenniki-archiwalne",
      function () {
        return require("private-next-pages/regulaminy-cenniki-archiwalne.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regulaminy-cenniki-archiwalne"])
      });
    }
  